import { render, staticRenderFns } from "./CnpjField.vue?vue&type=template&id=15804db4&scoped=true&"
import script from "./CnpjField.vue?vue&type=script&lang=js&"
export * from "./CnpjField.vue?vue&type=script&lang=js&"
import style0 from "./CnpjField.vue?vue&type=style&index=0&id=15804db4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15804db4",
  null
  
)

export default component.exports